export const COLORS = {
  primary: '#64b4ff',
  secondary: '#a0a078',
  success: '#50dc78',
  green: '#50dc78',
  warning: '#f0c83c',
  yellow: '#f0c83c',
  error: '#ff5050',
  red: '#ff5050',
  muted: '#64647a',
  dim: '#464655',
  bg: '#1a1a2e',
  surface: '#23233a',
  text: '#dcdce6',
  fg: '#dcdce6',
  accent: '#c792ea',
  cyan: '#80cbef',
  teal: '#28b4a0',
  orange: '#f09628',
  purple: '#9650c8',
  barBg: '#232332',
  barFill: '#64b4ff',
};

export const SPACING = {
  sidebarWidth: 28,
  padding: 1,
  gap: 1,
};
